import React from "react";
import { ValueDisplay, ValueDisplayProps } from "./ValueDisplay";
import Grid, { GridSize } from "@material-ui/core/Grid";

interface GridValueDisplayListProps {
	//List of ValueDisplayProps to display in the grid style.
	displayItems: ValueDisplayProps[];
	//A nullable field for setting the xs spacing
	itemSpacing_xs?: GridSize;
	//A nullable field for setting the sm spacing
	itemSpacing_sm?: GridSize;
	//A nullable field for setting the md spacing
	itemSpacing_md?: GridSize;
	//A nullable field for setting the lg spacing
	itemSpacing_lg?: GridSize;
	// should falsy values be rendered
	shouldSkipEmptyValues?: boolean;
}

/**
 * Takes in a list of ValueDisplayprops and lists them out in a grid style.
 * You can specify the spacing or use the defaults which are:
 * xs="auto", sm=12, md=6, lg=4
 * @param props
 */
export const GridValueDisplayList = (props: GridValueDisplayListProps) => (
	<Grid container spacing={2}>
		{props.displayItems
			.filter((i) => i.node || !props.shouldSkipEmptyValues)
			.map((item) => (
				<Grid
					item
					xs={props.itemSpacing_xs || "auto"}
					sm={props.itemSpacing_sm || 12}
					md={props.itemSpacing_md || 6}
					lg={props.itemSpacing_lg || 4}
					key={item.label}
					data-testid="value-display-item"
				>
					<ValueDisplay label={item.label} node={item.node} row={item.row}></ValueDisplay>
				</Grid>
			))}
	</Grid>
);
